export const FILTER_LABEL = {
  envelope: 'Envelope',
  document: 'CPF/CNPJ',
  email: 'E-mail',
  createStartDate: 'Data de criação - De:',
  createEndDate: 'Data de criação - Até:',
  signatureStartDate: 'Data de assinatura - De:',
  signatureEndDate: 'Data de assinatura - Até:',
};
